// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea-module--root--1msRb","label":"Textarea-module--label--2XS12 Form-module--stepLabel--3H1_D typography-module--responsiveTitle3--3gljT"};